import { Container, Grid, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LoginPopUp = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/auth");
  };

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mt: { xs: 1, md: 0 },
      }}
    >
      <Grid container sx={{ minHeight: "100vh", background: "white" }}>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: { xs: "none", sm: "block" },
            background: "url(/assets/Rectanglee.png) no-repeat center center",
            backgroundSize: "cover",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              color: "#BB84E8",
              top: { xs: "20px", sm: "30px" },
              left: { xs: "50px", sm: "100px" },
              fontSize: { xs: "1.5rem", sm: "2rem" },
              fontWeight: "800",
              fontFamily: "Vollkorn",
            }}
          >
            G2i
          </Box>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h2"
              align="center"
              sx={{
                fontWeight: "800",
                fontSize: { xs: "2rem", sm: "4rem", fontFamily: "Poppins" },
              }}
            >
              Log In
            </Typography>
            <Box
              sx={{
                position: "absolute",
                top: 30,
                left: "calc(100% - 110px)",
                transform: "translateX(-50%)",
              }}
            >
              <img
                src="/assets/Polygon.png"
                alt="Polygon"
                style={{ width: "220px", height: "220px" }}
              />
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: 200,
                left: 150,
                transform: "translateX(-50%)",
              }}
            >
              <img
                src="/assets/Polygon.png"
                alt="Polygon"
                style={{ width: "100px", height: "100px" }}
              />
            </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 230,
                transform: "translateX(-50%)",
              }}
            >
              <img
                src="/assets/Ellipse.png"
                alt="Ellipse"
                style={{ width: "380px", height: "260px" }}
              />
            </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: 100,
                left: 585,
                transform: "translateX(-50%)",
              }}
            >
              <img
                src="/assets/Ellipse 9.png"
                alt="Ellipse"
                style={{ width: "100px", height: "100px" }}
              />
            </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: 30,
                left: 605,
                transform: "translateX(-50%)",
              }}
            >
              <img
                src="/assets/Ellipse 9.png"
                alt="Ellipse"
                style={{ width: "60px", height: "60px" }}
              />
            </Box>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            p: { xs: 2, sm: 4 },
          }}
        >
          {/* Heading */}
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2rem" },
              textAlign: "center",
              mb: { xs: 2, sm: 3 },
              color: "#290854",
              fontWeight: "550",
              fontFamily: "Roboto",
            }}
          >
            account has been created please check your email for verification
          </Typography>

          {/* Log In Button */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{
              width: { xs: "70%", sm: "30%" },
              fontSize: { xs: "0.875rem", sm: "1rem" },
              px: { xs: 2, sm: 6 },
              mt: { xs: 10, sm: 18 },
              background: "#290854",
              color: "white",
              borderRadius: "14px",
            }}
            onClick={handleLoginClick}
          >
            Log In
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LoginPopUp;
